/* processor/reducer */
import { createReducer } from "typesafe-actions";
import { ProcessorActionTypes, ProcessorState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";

export const initialState: ProcessorState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>;

export default createReducer<ProcessorState, ActionType>(initialState)
  .handleType(ProcessorActionTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(ProcessorActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(ProcessorActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(ProcessorActionTypes.SAVE_REQUEST, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(ProcessorActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(ProcessorActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
      data: undefined,
    };
  })
  .handleType(ProcessorActionTypes.DELETE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(ProcessorActionTypes.DELETE_SUCCESS, (state) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
    };
  })
  .handleType(ProcessorActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  });
